<div class="contract-box box" data-testid="contract-performance-list">
    <div class="box-header">
        <div class="box-header-flex">
            <h4>{{ "overview.contract_performance" | translate }}</h4>
            <app-aw-tooltip [tooltipTitle]="'overview.contract_performance' | translate">
                <ng-container description>
                    {{ "overview.performance_tooltip" | translate }}
                </ng-container>
            </app-aw-tooltip>
        </div>

        @if (!sidebarService.isBelowMobileWidth()) {
            <p class="pointer" (click)="onLinkClick()" [routerLink]="['/contracts']" data-testid="contract-performance-list-open-list-link">
                <u>{{ "overview.open_list" | translate }}</u>
                <img src="../../../../assets/icons/arrow-up-blue.svg" style="transform: rotate(90deg)" alt="{{ 'customers.company_name' | translate }}" />
            </p>
        }
    </div>
    @if (!loading()) {
        <div style="position: relative">
            @if (contracts.fronts[0] === "") {
                <div class="empty-performance-overlay">
                    <p>{{ "overview.no_good_locations" | translate }}</p>
                </div>
            }
            <table style="width: 100%">
                <tr>
                    <th class="smaller-column" data-testid="contract-performance-list-front-header-contract-id">{{ "operator.contract_modal.contract_id" | translate }}</th>
                    <th class="locations-column" data-testid="contract-performance-list-front-header-locations">{{ "misc.locations" | translate }}</th>
                    <th class="smaller-column overflow-column" data-testid="contract-performance-list-front-header-performance">{{ "overview.front_runners" | translate }}</th>
                </tr>
                <tbody>
                    @for (contract of contracts.fronts; track $index) {
                        <tr [attr.data-testid]="'contract-performance-list-front-row-' + contract.contract_key">
                            <td
                                [routerLink]="contract.contract_id ? ['/contracts'] : null"
                                [queryParams]="{ id: contract.contract_key }"
                                class="{{ contract.contract_id ? 'pointer' : null }} smaller-column overflow-column"
                                [attr.data-testid]="'contract-performance-list-front-row-' + contract.contract_key + '-open-link'"
                            >
                                <u>{{ contract.contract_id }}</u>
                            </td>
                            <td class="locations-column" [attr.data-testid]="'contract-performance-list-front-row-' + contract.contract_key + '-locations-cell'">{{ contract.location_names ? contract.location_names.join(", ") : "" }}</td>
                            <td class="smaller-column" [style]="contract.performance < 0 ? 'color: #D81E5B' : 'color: #29E1B4'" [attr.data-testid]="'contract-performance-list-front-row-' + contract.contract_key + '-performance-cell'">
                                <strong>{{ round(contract.performance) }}&ensp;</strong>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
    @if (!loading()) {
        <div style="position: relative">
            @if (contracts.slackers[0] === "") {
                <div class="empty-performance-overlay">
                    <p>{{ "overview.no_bad_locations" | translate }}</p>
                </div>
            }
            <table style="width: 100%">
                <tr>
                    <th class="smaller-column" data-testid="contract-performance-list-slacker-header-contract-id"></th>
                    <th class="locations-column" data-testid="contract-performance-list-slacker-header-locations"></th>
                    <th class="smaller-column overflow-column" data-testid="contract-performance-list-slacker-header-performance">{{ "overview.slackers" | translate }}</th>
                </tr>
                <tbody>
                    @for (contract of contracts.slackers; track $index) {
                        <tr [attr.data-testid]="'contract-performance-list-slacker-row-' + contract.contract_key">
                            <td
                                [routerLink]="contract.contract_id ? ['/contracts'] : null"
                                [queryParams]="{ id: contract.contract_key }"
                                class="{{ contract.contract_id ? 'pointer' : null }} smaller-column overflow-column"
                                [attr.data-testid]="'contract-performance-list-slacker-row-' + contract.contract_key + '-open-link'"
                            >
                                <u>{{ contract.contract_id }}</u>
                            </td>
                            <td class="locations-column" [attr.data-testid]="'contract-performance-list-slacker-row-' + contract.contract_key + '-locations-cell'">{{ contract.location_names ? contract.location_names.join(", ") : "" }}</td>
                            <td class="smaller-column" [style]="contract.performance < 0 ? 'color: #D81E5B' : 'color: #29E1B4'" [attr.data-testid]="'contract-performance-list-slacker-row-' + contract.contract_key + '-performance-cell'">
                                <strong>{{ round(contract.performance) }}&ensp;</strong>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }

    @if (sidebarService.isBelowMobileWidth()) {
        <p class="pointer bottom-link" [routerLink]="['/contracts']" data-testid="contract-performance-list-open-list-mobile-link">
            <u>{{ "overview.open_list" | translate }}</u>
            <img src="assets/icons/arrow-up-blue.svg" style="transform: rotate(90deg)" alt="{{ 'customers.company_name' | translate }}" />
        </p>
    }

    @if (loading()) {
        <div class="loading-box">
            <app-loading-indicator [size]="'large'" [color]="'secondary'"></app-loading-indicator>
        </div>
    }
</div>
